module.exports = __webpack_public_path__ + "static/js/2.92a4fd7d.chunk.worker.js"